export default "__VITE_ASSET__LkWkMsqz__"